(function () {
  var configElement = document.getElementById('petsthing-tracking-config');

  if (!configElement || window.petsthingTrackingBooted) return;
  if (window.Shopify && window.Shopify.designMode) return;

  window.petsthingTrackingBooted = true;

  var config = {};
  var hasLoaded = false;
  var fallbackTimer;
  var interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'click'];

  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    config = {};
  }

  function hasScript(partialSrc) {
    var scripts = document.getElementsByTagName('script');
    var index;

    for (index = 0; index < scripts.length; index += 1) {
      if (scripts[index].src && scripts[index].src.indexOf(partialSrc) !== -1) {
        return true;
      }
    }

    return false;
  }

  function injectScript(src, id, onLoad) {
    var script;
    var firstScript;

    if (!src || hasScript(src.replace(/^https?:/, ''))) return null;
    if (id && document.getElementById(id)) return null;

    script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = src;

    if (id) script.id = id;
    if (typeof onLoad === 'function') script.onload = onLoad;

    firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    return script;
  }

  function userCanBeTracked() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!privacy) return true;

    try {
      if (typeof privacy.userCanBeTracked === 'function') {
        return privacy.userCanBeTracked();
      }

      if (typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  function loadClarity() {
    var projectId = config.clarityProjectId;

    if (!projectId || window.petsthingClarityLoaded) return;

    if (window.clarity || hasScript('clarity.ms/tag/' + projectId)) {
      window.petsthingClarityLoaded = true;
      return;
    }

    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

    injectScript('https://www.clarity.ms/tag/' + encodeURIComponent(projectId), 'petsthing-clarity');
    window.petsthingClarityLoaded = true;
  }

  function loadBingUet() {
    var tagId = config.bingUetTagId;

    if (!tagId || window.petsthingBingUetLoaded) return;

    window.uet_report_conversion = window.uet_report_conversion || function (payload) {
      var data = payload || {};
      var eventName = data.event || 'PRODUCT_PURCHASE';

      window.uetq = window.uetq || [];
      window.uetq.push('event', eventName, {
        ecomm_prodid: data.ecomm_prodid,
        ecomm_pagetype: data.ecomm_pagetype || 'PURCHASE',
        revenue_value: data.revenue_value,
        currency: data.currency || 'HKD'
      });

      return false;
    };

    if (hasScript('bat.bing.com/bat.js') || typeof window.UET === 'function') {
      window.petsthingBingUetLoaded = true;
      return;
    }

    window.uetq = window.uetq || [];

    injectScript('https://bat.bing.com/bat.js', 'petsthing-bing-uet', function () {
      if (typeof window.UET !== 'function' || window.petsthingBingUetReady) return;

      window.uetq = new window.UET({
        ti: tagId,
        enableAutoSpaTracking: true
      });
      window.uetq.push('pageLoad');
      window.petsthingBingUetReady = true;
    });

    window.petsthingBingUetLoaded = true;
  }

  function loadYotpo() {
    var loaderUrl = config.yotpoLoaderUrl;

    if (!loaderUrl || window.petsthingYotpoLoaded) return;

    if (hasScript('cdn-widgetsrepository.yotpo.com/v1/loader/') || window.yotpo) {
      window.petsthingYotpoLoaded = true;
      return;
    }

    injectScript(loaderUrl, 'petsthing-yotpo-loader');
    window.petsthingYotpoLoaded = true;
  }

  function loadHeatmap() {
    var heatmapUrl = config.heatmapUrl;

    if (!heatmapUrl || window.petsthingHeatmapLoaded) return;

    if (hasScript('u.heatmap.it/log.js')) {
      window.petsthingHeatmapLoaded = true;
      return;
    }

    injectScript(heatmapUrl, 'petsthing-heatmap');
    window.petsthingHeatmapLoaded = true;
  }

  function loadTracking() {
    if (hasLoaded) return;
    if (!userCanBeTracked()) return;

    hasLoaded = true;
    window.clearTimeout(fallbackTimer);

    loadClarity();
    loadBingUet();
    loadYotpo();
    loadHeatmap();

    window.dispatchEvent(new CustomEvent('petsthing:tracking-loaded'));
  }

  function removeInteractionListeners() {
    interactionEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, handleInteraction, true);
    });
  }

  function handleInteraction() {
    removeInteractionListeners();
    loadTracking();
  }

  function scheduleFallback() {
    var fallbackDelay = Number(config.fallbackDelay) || 10000;

    window.clearTimeout(fallbackTimer);
    fallbackTimer = window.setTimeout(loadTracking, fallbackDelay);
  }

  interactionEvents.forEach(function (eventName) {
    window.addEventListener(eventName, handleInteraction, {
      once: true,
      passive: true,
      capture: true
    });
  });

  window.addEventListener('visitorConsentCollected', loadTracking);

  if (document.readyState === 'complete') {
    scheduleFallback();
  } else {
    window.addEventListener('load', scheduleFallback, { once: true });
  }
})();
